import { render } from "./DataUsagesMaster.vue?vue&type=template&id=125c874b&scoped=true"
import script from "./DataUsagesMaster.vue?vue&type=script&lang=js"
export * from "./DataUsagesMaster.vue?vue&type=script&lang=js"

import "./DataUsagesMaster.vue?vue&type=style&index=0&id=125c874b&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125c874b"]])

export default __exports__